import type { ReactNode } from "react";

export type VerifiedArcadeId =
  | "three-six-nine"
  | "baskin-31"
  | "nunchi-count"
  | "bouncing-ball-chant"
  | "year-quiz"
  | "three-syllable-chain"
  | "word-association"
  | "mafia-local"
  | "categories"
  | "open-dice-rules"
  | "same-word-sync";

export const arcadeCardCopy: Record<VerifiedArcadeId, { label: string; hook: string; result: string }> = {
  "three-six-nine": { label: "숫자·박수", hook: "3·6·9가 보이면 숫자 대신 박수를 골라 20까지 이어 가요.", result: "박수 정답과 도달 숫자" },
  "baskin-31": { label: "숫자 전략", hook: "한 번에 1~3개를 골라 상대가 31을 말하도록 순서를 만들어요.", result: "31까지의 실제 숫자 흐름" },
  "nunchi-count": { label: "동시 반응", hook: "순서 없이 자기 버튼을 누르고, 두 사람이 겹치면 1부터 다시 시작해요.", result: "충돌 없는 완주 기록" },
  "bouncing-ball-chant": { label: "방향 연쇄", hook: "위즈·바운스·보잉으로 공의 다음 자리와 방향을 바꿔요.", result: "10회 연속 패스" },
  "year-quiz": { label: "연도 퀴즈", hook: "한국사와 생활 속 사건의 연도를 고르고 바로 정답을 확인해요.", result: "5문제 실제 정답 수" },
  "three-syllable-chain": { label: "세 글자", hook: "10초 안에 끝 글자로 시작하는 세 글자 카드를 골라 여섯 번 이어요.", result: "하트와 여섯 단어 연쇄" },
  "word-association": { label: "연상", hook: "세 카드 중 가장 직접 이어지는 단어를 골라 다섯 칸을 완주해요.", result: "이유가 있는 연상 경로" },
  "mafia-local": { label: "숨은 역할", hook: "역할을 한 명씩 비공개로 확인하고 밤 지목과 낮 투표로 승부해요.", result: "시민·마피아 승리 판정" },
  categories: { label: "주제 단어", hook: "12초 안에 함정을 피해 주제에 맞는 카드 네 장을 모두 찾아요.", result: "5라운드 정답 20개" },
  "open-dice-rules": { label: "운", hook: "주사위를 세 번 직접 굴려 각 눈과 최종 합계를 확인해요.", result: "세 번의 눈과 합계" },
  "same-word-sync": { label: "비공개 선택", hook: "각자 답을 숨겨 고른 뒤, 마지막에 우리 선택이 얼마나 겹쳤는지 공개해요.", result: "3개 선택지의 실제 분포" },
};

function PreviewScene({ id }: { id: VerifiedArcadeId }): ReactNode {
  if (id === "three-six-nine") return <div className="preview-369"><span>1</span><span>2</span><strong>짝!</strong><span>4</span></div>;
  if (id === "baskin-31") return <div className="preview-31"><span>28</span><span>29</span><span>30</span><strong>31</strong></div>;
  if (id === "nunchi-count") return <div className="preview-nunchi"><strong>다음 3</strong><span>1번</span><span>2번</span><span>3번</span><span>4번</span></div>;
  if (id === "bouncing-ball-chant") return <div className="preview-bounce"><svg viewBox="0 0 240 130"><path d="M31 89 Q120 7 207 87"/><circle cx="31" cy="89" r="16"/><circle cx="207" cy="87" r="16"/></svg><strong>WHIZ!</strong></div>;
  if (id === "year-quiz") return <div className="preview-year"><strong>1446</strong><span>1592</span><span>1948</span><i>정답</i></div>;
  if (id === "three-syllable-chain") return <div className="preview-chain"><span>강아지</span><i>→</i><span>지우개</span><i>→</i><span>개나리</span></div>;
  if (id === "word-association") return <div className="preview-association"><span>비</span><i>→</i><span>우산</span><i>→</i><span>장화</span></div>;
  if (id === "mafia-local") return <div className="preview-mafia"><span>시민</span><strong>?</strong><span>시민</span></div>;
  if (id === "categories") return <div className="preview-categories"><strong>과일</strong><span>사과 ✓</span><span>당근 ×</span><span>포도 ✓</span></div>;
  if (id === "same-word-sync") return <div className="preview-same-mind"><span>?</span><span>?</span><span>?</span><strong>2 · 1 · 1</strong></div>;
  return <div className="preview-dice"><span className="die die--one"><i/></span><span className="die die--four"><i/><i/><i/><i/></span><span className="die die--six"><i/><i/><i/><i/><i/><i/></span></div>;
}

export function GamePreview({ id, compact = false }: { id: VerifiedArcadeId; compact?: boolean }) {
  return <div className={`game-preview game-preview--${id} ${compact ? "game-preview--compact" : ""}`} data-preview={id} aria-hidden="true"><PreviewScene id={id}/></div>;
}
